import { render, staticRenderFns } from "./CheckboxesArray.vue?vue&type=template&id=4235aa6f&"
import script from "./CheckboxesArray.vue?vue&type=script&lang=js&"
export * from "./CheckboxesArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports